import React from 'react';

interface ToolBarProps {
  mode: 'view' | 'annotate';
  onModeChange: (mode: 'view' | 'annotate') => void;
  scale: number;
  onZoomIn: () => void;
  onZoomOut: () => void;
  onResetZoom: () => void;
  onExport: () => void;
}

const ToolBar: React.FC<ToolBarProps> = ({
  mode,
  onModeChange,
  scale,
  onZoomIn,
  onZoomOut,
  onResetZoom,
  onExport,
}) => {
  const buttonStyle = (active: boolean): React.CSSProperties => ({
    padding: '6px 14px',
    fontSize: '13px',
    border: active ? '2px solid #4A90D9' : '1px solid #ddd',
    borderRadius: '4px',
    background: active ? '#e8f0fe' : '#fff',
    cursor: 'pointer',
    fontWeight: active ? 600 : 400,
  });

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '8px 16px',
        borderBottom: '1px solid #ddd',
        background: '#fff',
        flexShrink: 0,
      }}
    >
      {/* Mode toggle */}
      <button onClick={() => onModeChange('view')} style={buttonStyle(mode === 'view')}>
        View
      </button>
      <button onClick={() => onModeChange('annotate')} style={buttonStyle(mode === 'annotate')}>
        Annotate
      </button>

      <div style={{ width: '1px', height: '24px', background: '#ddd', margin: '0 4px' }} />

      {/* Zoom controls */}
      <button onClick={onZoomOut} style={{ ...buttonStyle(false), padding: '6px 10px' }}>-</button>
      <span style={{ fontSize: '13px', minWidth: '48px', textAlign: 'center' }}>
        {Math.round(scale * 100)}%
      </span>
      <button onClick={onZoomIn} style={{ ...buttonStyle(false), padding: '6px 10px' }}>+</button>
      <button onClick={onResetZoom} style={{ ...buttonStyle(false), padding: '6px 10px' }}>Reset</button>

      <div style={{ width: '1px', height: '24px', background: '#ddd', margin: '0 4px' }} />

      <button
        onClick={onExport}
        style={{
          padding: '6px 14px',
          background: '#4A90D9',
          color: '#fff',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '13px',
        }}
      >
        Export Markdown
      </button>
    </div>
  );
};

export default ToolBar;
